import Select from "react-select";
import { useTranslation } from 'react-i18next';

// Custom styles for react-select to ensure solid backgrounds and proper z-index
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#ffffff',
    borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
    borderRadius: '8px',
    minHeight: '42px',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(59, 130, 246, 0.15)' : 'none',
    '&:hover': {
      borderColor: '#3b82f6'
    }
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    border: '1px solid #e2e8f0',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    zIndex: 9999,
    overflow: 'hidden'
  }),
  menuList: (provided) => ({
    ...provided,
    backgroundColor: '#ffffff',
    padding: '4px'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#3b82f6'
      : state.isFocused
        ? '#eff6ff'
        : '#ffffff',
    color: state.isSelected ? '#ffffff' : '#1e293b',
    padding: '10px 12px',
    cursor: 'pointer',
    borderRadius: '4px',
    margin: '2px 0',
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: state.isSelected ? '#3b82f6' : '#dbeafe',
      color: state.isSelected ? '#ffffff' : '#1e40af'
    },
    '&:active': {
      backgroundColor: state.isSelected ? '#2563eb' : '#bfdbfe'
    }
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#1e293b'
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#9ca3af'
  }),
  input: (provided) => ({
    ...provided,
    color: '#1e293b'
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999
  })
};

const FormSelect = ({ label, options, register, name, errors = {}, onChange, colSize = 4, required = true, value = undefined, isMulti=false, isClearable=false, disabled=false }) => {
  const { t } = useTranslation();
  const colClass = `col-lg-${colSize} mb-3`;

  // Handle the case when register is not provided
  const selectProps = register ? { ...register(name) } : {};

  return (
    <div className={colClass}>
      <div className="form-group">
        <label className="labelDescription">
          <span className="labelText">{t(label)}</span>
          {required && <span className="labelStar text-danger fw-bold">*</span>}
        </label>
        <Select
          {...selectProps}
          options={options}
          onChange={onChange}
          value={value}
          isMulti={isMulti}
          isClearable={isClearable}
          isDisabled={disabled}
          styles={customStyles}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          className={`dropdown rounded-0 ${errors[name] ? "requiredSelectInput" : ""}`}
        />
        {errors[name] && (
          <div className="error-message text-danger">
            {errors[name].message}
          </div>
        )}
      </div>
    </div>
  );
};

export default FormSelect;
